'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle(".nb-root {\n  width: 91px;\n  display: grid;\n}\n.nb-root .img {\n  display: flex;\n  align-items: center;\n}");
//# sourceMappingURL=NavBrand.scss.js.map
